import HTTPRetryUtil from 'src/utils/httpretry';
import path from 'path';
export const fetch_pivot_data = async (params, requirements, filters = []) => {
    const { projectId, dashboardId, chrysalisRef, chrysalis_url, topicId } = params;
    const chrysalisPath = path.join(chrysalisRef, '_topics', `${topicId}`, '_pivot_multi/');
    let tunnel_path = '';
    if (dashboardId) {
        tunnel_path = path.join('projects', `${projectId}`, 'dashboards', `${dashboardId}`, 'tunnel', chrysalisPath);
    }
    else {
        tunnel_path = path.join('projects', `${projectId}`, 'tunnel', chrysalisPath);
    }
    return await HTTPRetryUtil.post(tunnel_path, {
        body: { ...requirements, filters },
        config: {
            params: {
                chrysalis_url: chrysalis_url,
                invalidate_cache: false,
                topicId: topicId,
                chrysalisRef: chrysalisRef,
                allow_read_cache: false,
            }
        }
    });
};
export const fetch_keyphrases_data = async (params, requirements, filters = []) => {
    const { projectId, dashboardId, chrysalisRef, chrysalis_url, topicId } = params;
    const chrysalisPath = path.join(chrysalisRef, '_topics', `${topicId}`, 'keyphrase/search/');
    let tunnel_path = '';
    if (dashboardId) {
        tunnel_path = path.join('projects', `${projectId}`, 'dashboards', `${dashboardId}`, 'tunnel', chrysalisPath);
    }
    else {
        tunnel_path = path.join('projects', `${projectId}`, 'tunnel', chrysalisPath);
    }
    return await HTTPRetryUtil.post(tunnel_path, {
        body: { ...requirements, positive_only: true, filters },
        config: {
            params: {
                chrysalis_url: chrysalis_url,
                invalidate_cache: false,
                topicId: topicId,
                chrysalisRef: chrysalisRef,
                allow_read_cache: false,
            },
        },
    });
};
export const fetch_correlation_data = async (params, requirements, filters = []) => {
    const { projectId, dashboardId, chrysalisRef, chrysalis_url, topicId } = params;
    const chrysalisPath = path.join(chrysalisRef, '_topics', `${topicId}`, '_correlations/');
    let tunnel_path = '';
    if (dashboardId) {
        tunnel_path = path.join('projects', `${projectId}`, 'dashboards', `${dashboardId}`, 'tunnel', chrysalisPath);
    }
    else {
        tunnel_path = path.join('projects', `${projectId}`, 'tunnel', chrysalisPath);
    }
    return await HTTPRetryUtil.post(tunnel_path, {
        body: { ...requirements, filters },
        config: {
            params: {
                chrysalis_url: chrysalis_url,
                invalidate_cache: false,
                topicId: topicId,
                chrysalisRef: chrysalisRef,
                allow_read_cache: true,
            }
        }
    });
};
